import { formatFileSize } from "./fileUtils";

const MEGABYTE = 1024 * 1024;

export const MEDIA_TYPES_BY_MIME = {
  "image/jpeg": "image",
  "image/png": "image",
  "video/mp4": "video",
  "video/3gpp": "video",
  "audio/aac": "audio",
  "audio/mp4": "audio",
  "audio/mpeg": "audio",
  "audio/amr": "audio",
  "audio/ogg": "audio",
  "text/plain": "document",
  "application/pdf": "document",
  "application/msword": "document",
  "application/vnd.ms-excel": "document",
  "application/vnd.ms-powerpoint": "document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "document",
};

const MEDIA_TYPES_BY_EXTENSION = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  mp4: "video/mp4",
  "3gp": "video/3gpp",
  aac: "audio/aac",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  amr: "audio/amr",
  ogg: "audio/ogg",
  txt: "text/plain",
  pdf: "application/pdf",
  doc: "application/msword",
  xls: "application/vnd.ms-excel",
  ppt: "application/vnd.ms-powerpoint",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
};

export const MAX_SIZE_BY_TYPE = {
  image: 5 * MEGABYTE,
  video: 16 * MEGABYTE,
  audio: 16 * MEGABYTE,
  document: 20 * MEGABYTE,
};

const TYPE_LABELS = {
  image: "imágenes",
  video: "videos",
  audio: "audios",
  document: "documentos",
};

export const ACCEPT_ATTRIBUTE = [
  ...Object.keys(MEDIA_TYPES_BY_MIME),
  ...Object.keys(MEDIA_TYPES_BY_EXTENSION).map((extension) => `.${extension}`),
].join(",");

export const UNSUPPORTED_FILE_MESSAGE =
  "WhatsApp no acepta ese tipo de archivo. Se pueden mandar imágenes JPG o PNG, videos MP4, audios y documentos PDF, de texto u Office.";

export const mimeTypeOf = (file) => {
  const declared = (file?.type || "").split(";")[0].trim().toLowerCase();
  if (MEDIA_TYPES_BY_MIME[declared]) return declared;
  const extension = (file?.name || "").split(".").pop().toLowerCase();
  return MEDIA_TYPES_BY_EXTENSION[extension] || declared;
};

export const mediaTypeOf = (file) => MEDIA_TYPES_BY_MIME[mimeTypeOf(file)] || null;

export const validateWhatsAppFile = (file) => {
  if (!file) return "Elegí un archivo.";
  const mediaType = mediaTypeOf(file);
  if (!mediaType) return UNSUPPORTED_FILE_MESSAGE;
  const limit = MAX_SIZE_BY_TYPE[mediaType];
  if ((file.size || 0) > limit) {
    return `WhatsApp acepta ${TYPE_LABELS[mediaType]} de hasta ${formatFileSize(limit)}.`;
  }
  return null;
};
